/**
 * WorkflowFlowPage — Fullscreen workflow state machine visualization
 *
 * Opens in a new window from the Flow tab's expand button.
 * Shows the full state machine graph with current instance state
 * highlighted (when ?instance= and ?state= params provided).
 *
 * Route: /ferp-core/flow/:workflowId?instance=X&state=Y
 */

import { useParams, useSearchParams } from 'react-router-dom';
import { Container, Title, Group, Badge, Text } from '@mantine/core';
import { WorkflowFlowTab } from '@/components/entity-detail/tabs/WorkflowFlowTab';

export default function WorkflowFlowPage() {
  const { workflowId } = useParams<{ workflowId: string }>();
  const [searchParams] = useSearchParams();
  const instanceId = searchParams.get('instance');
  const currentState = searchParams.get('state');

  // Build a minimal entity object for the Flow tab
  const isInstance = !!instanceId;
  const entity = isInstance
    ? { id: instanceId, workflowDefinitionId: workflowId, currentState: currentState ?? '' }
    : { id: workflowId };

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Group px="md" py="xs" style={{ borderBottom: '1px solid var(--mantine-color-default-border)' }}>
        <Title order={4}>Workflow Flow</Title>
        <Text size="sm" c="dimmed">{workflowId}</Text>
        {currentState && (
          <Badge color="orange" variant="light">{currentState.replace(/_/g, ' ')}</Badge>
        )}
      </Group>
      <div style={{ flex: 1, overflow: 'auto', padding: 8 }}>
        <WorkflowFlowTab
          entity={entity as never}
          primitiveType={isInstance ? 'instance' : 'workflow'}
        />
      </div>
    </div>
  );
}
